import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { madeHere } from '../../data/home';
import { SectionTag } from '../shared/SectionTag';
export function MadeHere() {
  return <section className="bg-coal py-20 md:py-32" aria-labelledby="made-heading" data-id="element-32" data-mp="21tz07ack0034">
      <div className="mx-auto max-w-[1320px] px-5 md:px-8" data-id="element-33" data-mp="25thkq50gq95f">
        <div className="text-center lg:text-left" data-id="element-34" data-mp="2tju4qe8zfwcd">
          <SectionTag data-id="element-35" data-mp="2tl5667eygs0b">What we make</SectionTag>
          <h2 id="made-heading" className="mx-auto mt-5 max-w-3xl font-display text-[44px] font-bold uppercase leading-[0.9] text-chalk sm:text-5xl md:text-7xl lg:mx-0" data-id="element-36" data-mp="2yiybky8fphzj">
            Made in Our Umm Al Quwain Plant
          </h2>
        </div>

        <div className="mt-14 space-y-20 md:mt-16 md:space-y-28" data-id="element-37" data-mp="2pkcxbf9zwp4k">
          {madeHere.map((item, index) => <article key={item.slug} className="grid items-center gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-38" data-mp="196cyy8qst7jf" data-mpi={index}>
              <div className={`relative lg:col-span-7 ${index % 2 === 1 ? 'lg:order-2' : ''}`} data-id="element-39" data-mp="1e0qqg02cauit">
                <Link to={`/products/${item.slug}`} className="group block overflow-hidden rounded-[28px]" aria-label={`View ${item.linkLabel}`} data-id="element-40" data-mp="1v9th0ao19cdd">
                  <img src={item.image} alt={item.alt} loading="lazy" className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-out-strong group-hover:scale-[1.03]" data-id="element-41" data-mp="207ctp6531h37" />
                </Link>
              </div>

              <div className="text-center lg:col-span-5 lg:text-left" data-id="element-42" data-mp="2nvmcdz701oq4">
                <h3 className="font-display text-5xl font-bold uppercase leading-none text-chalk md:text-6xl" data-id="element-43" data-mp="2ix1alvc3mwzk">
                  {item.name}
                </h3>
                <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-muted lg:mx-0" data-id="element-44" data-mp="2wv9fcpfdn2la">{item.description}</p>
                <dl className="mt-8 space-y-5" data-id="element-45" data-mp="2zyyrwjn76jny">
                  <div data-id="element-46" data-mp="3009tqdx31hcf">
                    <dt className="text-sm font-bold uppercase tracking-[0.1em] text-flame" data-id="element-47" data-mp="300rwlte92ttb">Variants</dt>
                    <dd className="mt-1.5 text-chalk" data-id="element-48" data-mp="34vxl8zz1eml3">{item.variants}</dd>
                  </div>
                  <div data-id="element-49" data-mp="39v1qxgmr626o">
                    <dt className="text-sm font-bold uppercase tracking-[0.1em] text-flame" data-id="element-50" data-mp="3enuzkflcduo1">What to send us</dt>
                    <dd className="mt-1.5 text-chalk" data-id="element-51" data-mp="3ipya9206sv89">{item.sendUs}</dd>
                  </div>
                </dl>
                <Link to={`/products/${item.slug}`} className="mt-10 inline-flex h-14 items-center gap-2 whitespace-nowrap rounded-full border-2 border-flame px-8 font-bold uppercase tracking-[0.06em] text-chalk transition-colors duration-150 hover:bg-flame hover:text-ink" data-id="element-52" data-mp="3nnqcopygjzqp">
                  {item.linkLabel}
                  <ArrowUpRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-53" data-mp="238of32lcg63l" />
                </Link>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}